import { leadershipProfileEn, storyPillarsEn } from './skillsStory.en';
import { leadershipProfileAr, storyPillarsAr } from './skillsStory.ar';

export function getStoryPillars(lang = 'en') {
  return lang === 'ar' ? storyPillarsAr : storyPillarsEn;
}

export function getLeadershipProfile(lang = 'en') {
  return lang === 'ar' ? leadershipProfileAr : leadershipProfileEn;
}
